import { useSelector } from 'react-redux';
import { getEngagementLandingPath } from 'reports/cw/helpers/report.helper';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { isEAQStandalone } from 'reports/cw/services/courses.service';
var useEAQStandaloneCourse = function () {
    var courseSection = useSelector(courseSelectors.getCourseSectionInfo);
    var isEAQStandaloneCourse = isEAQStandalone(courseSection);
    var engagementLandingPath = getEngagementLandingPath(courseSection);
    return {
        isEAQStandaloneCourse: isEAQStandaloneCourse,
        engagementLandingPath: engagementLandingPath
    };
};
export default useEAQStandaloneCourse;
